module.exports = __webpack_public_path__ + "img/intro_7.b1e76f94.jpeg";